import {Typography} from "antd";

export const NotFound = () => {
  return <Typography.Title>There is no such page</Typography.Title>;
};
